import iconLogoFallback from "@/assets/icon-logo.webp?w=48&format=webp";
import iconLogo from "@/assets/icon-logo.webp?w=48;96&format=webp&as=srcset";
import topRightFallback from "@/assets/top-right.webp?w=240&format=webp";
import topRight from "@/assets/top-right.webp?w=240;480&format=webp&as=srcset";
import { FOOTER_LINKS, FOOTER_NAV_LINKS } from "@/lib/constants";
import { Link } from "react-router";

function Footer() {
  // This needs to be pushed sown smh
  return (
    <footer
      className="relative m-auto flex  w-full   flex-wrap-reverse items-center justify-center gap-5   overflow-hidden bg-secondary   text-sm
       sm:justify-between"
    >
      <img
        src={topRightFallback}
        srcSet={topRight}
        sizes="(min-width: 768px) 240px, 144px"
        className="pointer-events-none  absolute top-0 right-0  w-36 opacity-25 md:w-60"
        aria-hidden="true"
        loading="lazy"
        fetchPriority="low"
        alt=""
      />
      <div className=" flex w-full flex-col items-center justify-center gap-8 py-16">
        <a href="/">
          <img
            src={iconLogoFallback}
            srcSet={iconLogo}
            sizes="48px"
            alt="Sakeena Logo"
            className=" w-12"
            loading="lazy"
          />
        </a>

           <div className="flex cursor-pointer flex-wrap items-center justify-between gap-6">
          {FOOTER_LINKS.map(({ label, link, Icon }) => (
            <a
              key={label}
              href={link}
              target="_blank"
              className="mx-1 text-secondary-foreground transition-colors hover:text-secondary-foreground/70"
            >
              <Icon className="size-6" />
            </a>
          ))}
        </div>

        {/* Footer link */}
        <ul className=" flex flex-col items-center gap-3  md:flex-row md:gap-12">
          {FOOTER_NAV_LINKS.map(({ label, link }) => (
            <li key={link}>
              <Link
                to={`/${link}`}
                className="cursor-pointer text-xs text-secondary-foreground transition-colors hover:text-secondary-foreground/70 md:text-sm"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

     
        <p className="text-xs text-secondary-foreground md:text-sm">
          © 2026 Kodelle. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
